<template>
  <m-dialog ref="dlg" @save="save" title="Pilih">
    <v-row no-gutters justify="center" align="center">
      <v-col cols="12" sm="12" md="10" lg="8" xl="8">
        <v-form @submit.prevent data-vv-scope="form" lazy-validation>
          <v-card flat class="mt-4 mb-5 pb-5">
            <v-card-text class="pa-5 pt-0">
              <v-row no-gutters>
                <v-col cols="12" class="mt-5">
                  <v-row no-gutters>
                    <v-col cols="12" sm="6" md="6" lg="6">
                      <v-select
                        class="mr-2"
                        outlined
                        dense
                        closable
                        autocomplete="false"
                        v-model="peran_id"
                        :items="itemPerans"
                        no-data-text="Data Tidak Tersedia"
                        placeholder="Pilih Peran"
                        label="Peran"
                        name="Peran"
                        @change="loadKandidat"
                        item-value="grup_id"
                        item-text="label"
                        data-vv-name="peran"
                        data-vv-as="Peran"
                        v-validate="'required'"
                        :error-messages="errors.collect('form.peran')"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" lg="6">
                      <v-text-field
                        outlined
                        dense
                        autofocus
                        v-model="textSearch"
                        placeholder="Cari Pengguna"
                        hint
                        clearable
                        append-icon="mdi-magnify"
                        @click:append="search()"
                        @keyup.enter="search()"
                        @click:clear="search()"
                        persistent-hint
                        :error-messages="errors.collect('form.instansi')"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="4" lg="4">
                      <v-autocomplete
                        class="mr-2"
                        outlined
                        dense
                        clearable
                        :items="itemPropinsies"
                        @change="fetchKota(propinsi)"
                        label="Propinsi"
                        name="Propinsi"
                        placeholder="Pilih Propinsi"
                        v-model="propinsi"
                        hint="Pilih Propinsi"
                        data-vv-name="Propinsi"
                        data-vv-as="Propinsi"
                        item-text="keterangan"
                        item-value="k_propinsi"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="12" md="4" lg="4">
                      <v-autocomplete
                        :disabled="!propinsi"
                        class="mr-2"
                        outlined
                        dense
                        clearable
                        :items="itemKotas"
                        @change="fetchKecamatan(kota)"
                        label="Kota"
                        name="Kota"
                        placeholder="Pilih Kota"
                        v-model="kota"
                        hint="Pilih Kota"
                        data-vv-name="kota"
                        data-vv-as="Kota"
                        item-text="keterangan"
                        item-value="k_kota"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="12" md="4" lg="4">
                      <v-autocomplete
                        :disabled="!kota"
                        class="mr-2"
                        outlined
                        dense
                        clearable
                        :items="itemKecamatans"
                        @change="loadKandidat"
                        label="Kecamatan"
                        name="Kecamatan"
                        placeholder="Pilih Kecamatan"
                        v-model="kecamatan"
                        hint="Pilih Kecamatan"
                        data-vv-name="kecamatan"
                        data-vv-as="Kecamatan"
                        item-text="keterangan"
                        item-value="k_kecamatan"
                      ></v-autocomplete>
                    </v-col>

                    <v-col cols="12" sm="12" md="12" lg="12">
                      <v-chip
                        class="ma-1"
                        v-for="item in selectedItems"
                        :key="item.id"
                        close
                        @click:close="removeSelected(item)"
                      >
                        <v-avatar left>
                          <v-icon>mdi-account-circle</v-icon>
                        </v-avatar>
                        {{ item.name }}
                      </v-chip>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" lg="12">
                      <v-data-table
                        v-model="selectedItems"
                        :headers="headers"
                        :items="itemKandidats"
                        :items-per-page="15"
                        item-key="id"
                        show-select
                        hide-default-footer
                      >
                        <template v-slot:body="{ items }">
                          <tbody>
                            <tr v-if="items.length == 0">
                              <td colspan="3" align="center">Data Tidak Tersedia</td>
                            </tr>
                            <tr v-for="item in items" :key="item.id">
                              <td>
                                <v-checkbox
                                  v-model="selectedItems"
                                  :value="item"
                                  style="margin:0px;padding:0px"
                                  hide-details
                                />
                              </td>
                              <td>{{ pVal(item, "name") }}</td>
                              <td>{{ pVal(item, "email") }}</td>
                              <td>
                                <div v-if="item.kecamatan" class="mt-2">
                                  <span class="primary--text">
                                    {{ pVal(item.kecamatan.kota.propinsi, "keterangan") }} </span
                                  >,
                                  <span class="teal--text">{{ pVal(item.kecamatan.kota, "keterangan") }}</span>
                                  <p class="orange--text">Kec. {{ pVal(item.kecamatan, "keterangan") }}</p>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </template>
                        <template v-slot:footer>
                          <v-row wrap class="pb-3" v-if="page && page.last_page > 1">
                            <v-col
                              :cols="$vuetify.breakpoint.smAndUp ? 2 : 3"
                              class="text-left"
                              align="center"
                              justify="center"
                            >
                              <p class="caption font-weight-bold">{{ page.total }} &nbsp; Data ditemukan</p>
                            </v-col>
                            <v-col cols="8" v-if="$vuetify.breakpoint.smAndUp" class="text-center">
                              <v-pagination
                                v-if="page.total"
                                :key="page_key"
                                v-model="current_page"
                                :length="page.last_page"
                                :total-visible="7"
                                @input="change"
                              ></v-pagination>
                            </v-col>
                            <v-col :cols="$vuetify.breakpoint.smAndUp ? 2 : 9" v-if="page.from" class="text-right">
                              <p class="caption font-weight-bold">
                                {{ page.from }} - {{ page.to }} dari {{ page.total }}
                              </p>
                            </v-col>
                          </v-row>
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-form>
      </v-col>
    </v-row>
  </m-dialog>
</template>

<script>
import { ALERT_INFO } from "@/const";
import FilterJenisTingkat from "@/filter/FilterJenisTingkat.vue";
export default {
  $_veeValidate: {
    validator: "new"
  },
  components: {
    FilterJenisTingkat
  },

  data() {
    return {
      peran_id: null,
      grup: null,
      itemPerans: [
        {
          id: 8,
          keterangan: "Peserta"
        },
        {
          id: 4,
          keterangan: "Pendamping"
        }
      ],
      duplicate: false,
      enroll: [],
      tipe: "",
      modul_id: null,
      textSearch: "",
      itemKandidats: [],
      propinsi: null,
      kota: null,
      kecamatan: null,
      itemPropinsies: [],
      itemKotas: [],
      itemKecamatans: [],
      countMapelPilihan: 1,
      alert: ALERT_INFO,
      selectedItems: [],
      page: null,
      cp: 1,
      current_page: 0,
      jump_page: 0,
      selection: [],
      pagging: {},
      page_key: 0,
      totalPagination: [],
      headers: [
        { text: "Nama", align: "left", value: "nama" },
        { text: "Surel", align: "left", value: "email" },
        { text: "Wilayah", align: "left", value: "wilayah" }
      ]
    };
  },
  methods: {
    // eslint-disable-next-line
    open(grup) {
      this.grup = grup;
      this.propinsi = null;
      this.itemKandidats = [];
      this.selectedItems = [];
      this.enroll = [];
      this.load()
      this.loadKandidat();
      this.fetchPropinsi();

      let x = this.$refs.dlg.open();
      this.$validator.reset();
      return x;
    },
    removeSelected(item) {
      const tempSelected = this.selectedItems;
      const shallowCopyArray = Array.from(tempSelected);
      const index = shallowCopyArray.indexOf(item);
      if (index > -1) {
        shallowCopyArray.splice(index, 1);
      }
      this.selectedItems = shallowCopyArray;
    },

    load() {
      return this.$store
        .dispatch("kelas/getPeran", {
          instansi_id: this.instansi_id,
          diklat_id: this.diklat_id,
          params: {
          }
        })
        .then(res => {
          this.itemPerans = res.filter(peran=>peran.grup_id==8 || peran.grup_id==4);
        })
        .catch(e => e);
    },

    search() {
      this.current_page = 1;
      this.cp = 1;
      this.loadKandidat();
    },

    // eslint-disable-next-line
    loadKandidat() {
      var selected = this.selectedItems;
      return this.$store
        .dispatch("kelas/getKandidatGrup", {
          instansi_id: this.instansi_id,
          diklat_id: this.diklat_id,
          kelas_id: this.$route.params.kelas_id,
          kelas_modul_id: this.grup.kelas_modul_id,
          grouping_id: this.grup.kelas_gruping_id,
          group_id: this.grup.id,

          params: {
            page: this.cp,
            grup_id: this.peran_id,
            s: this.textSearch,
            k_propinsi: this.propinsi,
            k_kota: this.kota,
            k_kecamatan: this.kecamatan
          }
        })
        .then(res => {
          this.page = res;
          this.itemKandidats = res.data;
          return (this.selectedItems = []);
        })
        .then(() => {
          return (this.selectedItems = selected);
        })
        .catch(e => e);
    },

    // eslint-disable-next-line
    fetchPropinsi() {
      return this.$store
        .dispatch("enroll/getPropinsi")
        .then(res => {
          this.itemPropinsies = res;
          this.loadKandidat();
        })
        .catch(e => e);
    },

    // eslint-disable-next-line
    fetchKota(k_propinsi) {
      if (!k_propinsi) return;
      return this.$store
        .dispatch("enroll/getKota", this.propinsi)
        .then(res => {
          this.itemKotas = res;
          this.loadKandidat();
        })
        .catch(e => e);
    },

    // eslint-disable-next-line
    fetchKecamatan(k_kota) {
      if (!k_kota) return;
      return this.$store
        .dispatch("enroll/getKecamatan", { k_propinsi: this.propinsi, k_kota: this.kota })
        .then(res => {
          this.itemKecamatans = res;
          this.loadKandidat();
        })
        .catch(e => e);
    },

    change() {
      if (this.current_page !== this.page.current_page) {
        this.cp = this.current_page;
        this.loadKandidat();
      }
    },
    // eslint-disable-next-line
    save() {
      this.selectedItems.forEach(item => {
        var obj = {
          user_id: item.id,
          grup_id: this.tipe
        };
        this.enroll.push(obj);
      });

      return this.$store
        .dispatch("kelas/formKandidat", {
          instansi_id: this.instansi_id,
          diklat_id: this.diklat_id,
          kelas_id: this.$route.params.kelas_id,
          kelas_modul_id: this.grup.kelas_modul_id,
          grouping_id: this.grup.kelas_gruping_id,
          group_id: this.grup.id,
          obj: this.enroll
        })
        .then(() => {
          return this.$store.dispatch("kelas/getGrup", {
            instansi_id: this.instansi_id,
            diklat_id: this.diklat_id,
            kelas_id: this.$route.params.kelas_id
          });
        })
        .then(() => {
          this.selectedItems = [];
          this.enroll = [];
          this.$refs.dlg.resolve();
        })
        .catch(e => e);
    }
  },
  watch: {
    page(n) {
      if (n) {
        this.current_page = n.current_page;
        this.jump_page = n.current_page;
        this.page_key = Math.random();
        for (let i = 1; i <= n.last_page; i++) {
          this.totalPagination.push(i);
        }
      }
    },
    items() {
      this.current_page = this.page ? this.page.current_page : 0;
    },
    propinsi(n) {
      if (!n) {
        this.kota = null;
        this.kecamatan = null;
        this.loadKandidat();
      }
    },
    kota(n) {
      if (!n) {
        this.kecamatan = null;
        this.loadKandidat();
      }
    },
    kecamatan(n) {
      if (!n) {
        this.loadKandidat();
      }
    }
  }
};
</script>
<style>
.date-time {
  color: rgba(0, 0, 0, 0.87);
  padding: 8px 8px 8px;
  max-width: 100%;
  width: 100%;
  border: 1px solid grey;
  outline: 1px;
  background: transparent;
  border-radius: 4px;
}
</style>
